import {
  LabeledVehiclesDispatchTypes,
  LABELED_VEHICLES_LOADING,
  LABELED_VEHICLES_SUCCESS,
  LabeledVehicles,
} from "../actions/labeledVehiclesActionTypes";

interface DefaultStateInterface {
  hasData?: boolean;
  labeledVehicles?: Array<LabeledVehicles>;
  loading: boolean;
}

const defaultState: DefaultStateInterface = {
  hasData: false,
  loading: false,
};

const labeledVehiclesReducer = (
  state: DefaultStateInterface = defaultState,
  action: LabeledVehiclesDispatchTypes
): DefaultStateInterface => {
  switch (action.type) {
    case LABELED_VEHICLES_LOADING:
      return {
        loading: true,
      };
    case LABELED_VEHICLES_SUCCESS:
      return {
        loading: false,
        labeledVehicles: action.payload,
        hasData: true,
      };
    default:
      return state;
  }
};

export default labeledVehiclesReducer;
